import { DropdownMenu } from '../../../components/DropdownMenu'
import type { NavigationProps } from './types'

interface MobileNavigationProps extends NavigationProps {
  isOpen: boolean
}

export function MobileNavigation({
  isOpen,
  items,
  openDropdowns,
  toggleDropdown,
}: MobileNavigationProps) {
  return (
    <div
      className={`${
        isOpen ? 'block' : 'hidden'
      } absolute top-[60px] right-0 left-0 bg-gray-800 p-4 sm:hidden`}
    >
      <ul className="space-y-2">
        <li>
          <a
            href="/"
            className="block rounded px-3 py-2 text-white hover:bg-gray-700"
          >
            Home
          </a>
        </li>
        {items.map((item) => (
          <li key={item.label}>
            {item.href ? (
              <a
                href={item.href}
                className="block rounded px-3 py-2 text-white hover:bg-gray-700"
              >
                {item.label}
              </a>
            ) : item.onClick ? (
              <button
                type="button"
                onClick={item.onClick}
                className="block w-full rounded px-3 py-2 text-center text-white hover:bg-gray-700"
              >
                {item.label}
              </button>
            ) : (
              <DropdownMenu
                item={item}
                isOpen={openDropdowns[item.label]}
                toggleDropdown={toggleDropdown}
                isMobile
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
